import React, { useState, createContext } from "react";

export const MainContext = createContext(null);

export const MainProvider = ({ children }) => {
  const [buttons, setButtons] = useState(["button1", "button2", "button3", "button4"]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [isLoadUserId, setIsLoadUserId] = useState(false);
  const [archive, setArchive] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [serviceByDate, setServiceByDate] = useState([]);
  const [undefinedUserId, setUndefinedUserId] = useState(false);
  const [user, setUser] = useState({});
  const [action, setAction] = useState([]);
  const [waypoints, setWaypoints] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [fetchFaults, setFetchFaults] = useState([]);
  const [fetchPdf, setFetchPdf] = useState([]);
  const [ordersCurrent, setOrdersCurrent] = useState([]);
  const [ordersResolved, setOrdersResolved] = useState([]);
  const [isStatusActiveIcon, setIsStatusActiveIcon] = useState(false);

  return (
    <MainContext.Provider
      value={{
        buttons,
        setButtons,
        openModal,
        setOpenModal,
        selectedMarker,
        setSelectedMarker,
        isLoadUserId,
        setIsLoadUserId,
        archive,
        setArchive,
        markers,
        setMarkers,
        userLocation,
        setUserLocation,
        serviceByDate,
        setServiceByDate,
        undefinedUserId,
        setUndefinedUserId,
        user,
        setUser,
        action,
        setAction,
        waypoints,
        setWaypoints,
        activeUsers,
        setActiveUsers,
        fetchFaults,
        setFetchFaults,
        fetchPdf,
        setFetchPdf,
        ordersCurrent,
        setOrdersCurrent,
        ordersResolved,
        setOrdersResolved,
        isStatusActiveIcon,
        setIsStatusActiveIcon,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};
